export function isEmpty(value: Array<any> | Record<any, any> | string): boolean {
    if (typeof value === 'string') {
        return value.length === 0;
    } else if (Array.isArray(value)) {
        return value.length === 0;
    }

    return Object.keys(value).length === 0;
}
